module.exports = __webpack_public_path__ + "img/case3-2.fc49a02b.png";